const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
const API_URL_PROD = process.env.REACT_APP_BASE_URL_PROD;
const API_URL_LOCAL = process.env.REACT_APP_BASE_URL_LOCAL;
const PUBLIC_URL_LOCAL = process.env.REACT_APP_BACKEND_URL_LOCAL;
const BACKEND_URL_PROD = process.env.REACT_APP_BACKEND_URL_PROD;
const SOCKET_URL_LOCAL = process.env.REACT_APP_SOCKET_URL_LOCAL;
const SOCKET_URL_PROD = process.env.REACT_APP_SOCKET_URL_PROD;
const API_URL_DEV = process.env.REACT_APP_BASE_URL_DEV;
const BACKEND_URL_DEV = process.env.REACT_APP_BACKEND_URL_DEV;
const SOCKET_URL_DEV = process.env.REACT_APP_SOCKET_URL_DEV;
const AWS_URL_LOCAL = process.env.REACT_APP_AWS_URL_LOCAL;
const AWS_URL_DEV = process.env.REACT_APP_AWS_URL_DEV;
const AWS_URL_PROD = process.env.REACT_APP_AWS_URL_PROD;
const config = {
  base: {
    url: API_URL_LOCAL,
    public: PUBLIC_URL_LOCAL,
    socket: SOCKET_URL_LOCAL,
    awsUrl: AWS_URL_LOCAL,
  },
};

//CHECK FOR ENVIRONMENT
if (ENVIRONMENT === "prod") {
  config.base.url = API_URL_PROD;
  config.base.public = BACKEND_URL_PROD;
  config.base.socket = SOCKET_URL_PROD;
  config.base.awsUrl = AWS_URL_PROD;
} else if (ENVIRONMENT === "dev") {
  config.base.url = API_URL_DEV;
  config.base.public = BACKEND_URL_DEV;
  config.base.socket = SOCKET_URL_DEV;
  config.base.awsUrl = AWS_URL_DEV;
} else {
  config.base.url = API_URL_LOCAL;
  config.base.public = PUBLIC_URL_LOCAL;
  config.base.socket = SOCKET_URL_LOCAL;
  config.base.awsUrl = AWS_URL_LOCAL;
}

export { config, ENVIRONMENT };
